import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CatalogItemViewReducerStateShape } from './types';
import { catalogItemViewReducerPath } from './const';

const isListWithAssesmentInstructionCompleted = 0b01;
const isListWithAssesmentInstructionCompletedByRegisteredUser = 0b10;

export const catalogItemViewSlice = createSlice({
  name: catalogItemViewReducerPath,
  initialState: 0,
  reducers: {
    setListInstructionCompleted(state, action: PayloadAction<boolean>) {
      return action.payload ? (state |= isListWithAssesmentInstructionCompleted) : (state &= ~isListWithAssesmentInstructionCompleted);
    },
    setListInstructionCompletedByRegisteredUser(state, action: PayloadAction<boolean>) {
      return action.payload
        ? (state |= isListWithAssesmentInstructionCompletedByRegisteredUser)
        : (state &= ~isListWithAssesmentInstructionCompletedByRegisteredUser);
    },
  },
});

export const catalogItemViewReducerConfig = {
  [catalogItemViewReducerPath]: catalogItemViewSlice.reducer,
};

export const catalogItemViewListInstructionCompletedSelector = (state: CatalogItemViewReducerStateShape) =>
  (state[catalogItemViewReducerPath] & isListWithAssesmentInstructionCompleted) !== 0;

export const catalogItemViewListInstructionCompletedByRegisteredUserSelector = (state: CatalogItemViewReducerStateShape) =>
  (state[catalogItemViewReducerPath] & isListWithAssesmentInstructionCompletedByRegisteredUser) !== 0;
